import { Injectable } from '@angular/core';

import { Router } from '@angular/router';

// campfire
import { PartnerBrandService, IntercomService, LoggerService } from '@campfire-nx/api';
import { TpaService } from '@open-portal-app/core/services/tpa.service';

// constants
import { POLICY_ACTIONS } from '@open-portal-app/core/constants/policy.constants';

@Injectable({
  providedIn: 'root'
})
export class PolicyActionService {
  constructor(
    private partnerBrandService: PartnerBrandService,
    private intercomService: IntercomService,
    private router: Router,
    private tpaService: TpaService,
    private loggerService: LoggerService
  ) { }

  claimsEvent(policy: any, claimSlug: string) {
    this.router.navigate([`/policy/${policy.productClass}/${policy.slug}/claim/${claimSlug}`]);
  }

  goToSupport(policy: any, supportType: string) {
    this.router.navigate(['/support'], {
      queryParams: {
        action: 'help_flow',
        subject: supportType,
        'reference-list': policy.slug,
        'product-class': policy.productClass,
        'return-url': encodeURIComponent(window.location.href)
      }
    });
  }

  goToClaims(policy: any) {
    const intercomData = this.partnerBrandService.getAttribute('intercom', 'partner');
    const isIntercomEnabled = intercomData?.intercomAppId;

    const singleTpa = policy.fnolTPAs?.length === 1;
    const multipleTpa = policy.fnolTPAs?.length > 1;
    let doMultipleTpaApply = false;

    if (policy.fnolTPAs && policy.fnolTPAs.length > 0) {
      // doMultipleTpaApply: Does policy have extras that make multiple TPAs relevant for the policy
      doMultipleTpaApply = this.checkPolicyForIncludedTpaExtras(policy);
    }
    
    if (policy.fnolThirdParty) {
      if (policy.fnolViaIntercom && isIntercomEnabled) {
        // Open Intercom widget
        this.intercomService.show();
      } else if (singleTpa || !doMultipleTpaApply) {
        // Call Handover API to fetch default TPA url
        this.handoverToTPA(policy, 'default');
      } else if (multipleTpa && doMultipleTpaApply) {
        // Let customer choose claim TPA type on claim triage page
        this.goToClaimTriage(policy);
      } else {
        this.goToSupport(policy, 'claim');
      }
    } else {
      this.goToSupport(policy, 'claim');
    }
  }


  checkPolicyForIncludedTpaExtras(policy: any) {
    let numberOfTPAextras = 0;
    for (const tpaItem of policy.fnolTPAs) {
      for (const [key, value] of Object.entries<{is_included?: boolean}>(policy?.rawExtras || {})) {
        if (tpaItem?.for_cover?.includes(key) && value?.is_included === true) {
            numberOfTPAextras += 1;
        }
      }
    }
    return numberOfTPAextras > 0;
  }

  goToClaimTriage(policy: any) {
    this.router.navigate([`/policy/${policy?.productClass}/${policy.slug}/claim-triage`]);
  }

  handoverToTPA(policy: any, forCover:string) {
    this.tpaService.handoverToTpa({
      policy_uuid: policy.slug,
      for_cover: forCover
    }).then((response: any) => {
      if (response?.url && response?.url !== '') {
        window.open(response?.url, '_blank');
      }
    }
    ).catch((err: any) => {
      this.loggerService.error('PolicyDetailsComponent', 'handoverToTPA', { error: err });
    });
  }

  getActions(componentData: any) {
    let actionMarkup = [];
    if (componentData.policyState === 'active') {
      actionMarkup = POLICY_ACTIONS.ACTIVE_ACTIONS;
      return actionMarkup;
    }

    if (componentData.policyState === 'cancelled') {
      actionMarkup = POLICY_ACTIONS.CANCELLED_ACTIONS;
      return actionMarkup;
    }

    if (componentData.policyState === 'inactive') {
      actionMarkup = POLICY_ACTIONS.INACTIVE_ACTIONS;
      return actionMarkup;
    }
    
    if (componentData.policyState === 'upcoming') {
      actionMarkup = POLICY_ACTIONS.UPCOMING_ACTIONS;
      return actionMarkup;
    }

    return [];
  }
}
